// WHY: ONE rule for turning a typed Indian mobile number into the stored form
// "+91XXXXXXXXXX" (E.164). AddUser and EditUser both use it, so a technician's
// phone is always stored the way OTP login looks it up (phoneMatches() in
// firestore.rules, AuthContext's phone fallback) - LOW-13. The logic is moved
// unchanged from AddUser.jsx (D-241).

export const PHONE_ERROR = "Please enter a valid 10-digit mobile number.";

// Returns { ok, phone, empty, error }.
//   ""                -> { ok: true,  phone: "", empty: true }
//   valid 10 digits   -> { ok: true,  phone: "+91XXXXXXXXXX" }
//   anything else     -> { ok: false, phone: "", error: PHONE_ERROR }
export function normaliseIndianMobile(raw) {
  const compact = String(raw ?? "").replace(/\s+/g, "").trim();
  if (compact === "") return { ok: true, phone: "", empty: true };

  let digits = compact.replace(/\D/g, "");
  // "919876543210" -> strip the country code
  if (digits.startsWith("91") && digits.length === 12) digits = digits.slice(2);
  // "09876543210" -> strip the local-dialling 0
  if (digits.startsWith("0") && digits.length === 11) digits = digits.slice(1);

  if (digits.length !== 10) return { ok: false, phone: "", empty: false, error: PHONE_ERROR };
  return { ok: true, phone: "+91" + digits, empty: false };
}